
import * as types from '../constants/actionTypes';
import  { wrapCall, cacheCall } from '../utils/serviceUtils';
import { api, fileApi } from '../services';

// service calls as redux thunk actions

// fetch dsa list
export const fetchDSAs = (page = 1) => {
  let offset = page - 1;
  return wrapCall(api.get(`/dsa?offset=${offset}`), 'fetch_dsas');
};

// fetch dsa config
export const fetchDSAConfig = (dsa_id) =>
  cacheCall(api, 'get', '/dsa/config', 'fetch_dsa_config', {}, 60000, {dsa_id: dsa_id});


// fetch dsa details
export const fetchDSA = (id) => {
  id = int(id);
  //return cacheCall(api, 'get', '/dsa/' + id, 'dsa', {id}, 0);
  return wrapCall(api.get('/dsa/' + id), 'fetch_dsa', {id});
};


// toggle business area (active/enabled) for an dsa
export const toggleBusinessArea = (dsaAreaId, active) => {
  dsaAreaId = int(dsaAreaId);
  return wrapCall(
    api.post(`/dsaarea/${active ? 'enable' : 'disable'}/${dsaAreaId}`),
    types.TOGGLE_BUSINESS_AREA,
    {
      dsaAreaId,
      active
    }
  );
};

export const updateDSAAreaNote = (dsaAreaId, note) => {
  dsaAreaId = int(dsaAreaId);
  return wrapCall(api.post('/dsaarea/' + dsaAreaId, {note}), types.UPDATE_DSA_AREA_NOTE, {
    dsaAreaId,
    note
  });
};


// answer an dsa goal question
export const updateDSAGoalAnswer = (dsaGoalId, answer) => {
  dsaGoalId = int(dsaGoalId);
  return wrapCall(api.post('/dsagoal/' + dsaGoalId, {answer}), types.ANSWER_DSA_GOAL, {
    dsaGoalId,
    answer
  });
};


// answer an dsa use question
export const answerDSAUseQuestion = (dsaUseQuestionId, answer) => {
  dsaUseQuestionId = int(dsaUseQuestionId);
  return wrapCall(api.post('/dsausequestion/' + dsaUseQuestionId, {answer}), types.ANSWER_DSA_USE_QUESTION, {
    dsaUseQuestionId,
    answer
  });
};

export const answerDSAValueRealized = (dsaValueRealizedId, answer) => {
  dsaValueRealizedId = int(dsaValueRealizedId);
  return wrapCall(api.post('/dsavaluerealized/' + dsaValueRealizedId, {answer}), types.ANSWER_DSA_VALUE_REALIZED, {
    dsaValueRealizedId,
    answer
  });
};


// save data input for configured item to local store (but, don't push to server)
export const changeDSAConfiguredItem = (dsaConfiguredItemId, attr) => {
  dsaConfiguredItemId = int(dsaConfiguredItemId);
  return dispatch => {
    return dispatch({type: types.CHANGE_DSA_CONFIGURED_ITEM, dsaConfiguredItemId, attr});
  };
};


// post data input to the API
export const updateDSAConfiguredItem = (dsaConfiguredItemId, attr) => {
  dsaConfiguredItemId = int(dsaConfiguredItemId);
  return wrapCall(api.post('/dsaconfigureditem/' + dsaConfiguredItemId, attr), types.UPDATE_DSA_CONFIGURED_ITEM, {
    dsaConfiguredItemId,
    attr
  });
};

// save peak buffer percent to dsa
export const updatePeakBuffer = (dsaId, peakBuffer) => {
  dsaId = int(dsaId);
  return wrapCall(api.post('/dsa/' + dsaId, { peak_buffer: peakBuffer }), types.UPDATE_PEAK_BUFFER, {
    dsaId,
    peakBuffer
  });
};

export const updateDSA = (dsaId, updates) => {
  dsaId = int(dsaId);
  return wrapCall(api.post('/dsa/' + dsaId, updates), types.UPDATE_DSA, {
    dsaId,
    updates
  });
};

export const createDSA = params => {
  return wrapCall(api.post('/dsa', params), 'create_dsa', params);
};

export const markDSAAsPresented = dsaId => {
  dsaId = int(dsaId);
  return wrapCall(api.post('/dsa/' + dsaId, { presented: true, presentedDate: new Date() }), 'mark_dsa_as_presented', {
    dsaId
  });
};

export const markDSAAsClosed = dsaId => {
  dsaId = int(dsaId);
  return wrapCall(api.post('/dsa/' + dsaId, { state: 'closed' }), 'mark_dsa_as_closed', {
    dsaId
  });
};

export const cloneDSA = params => {
  return wrapCall(
    api.post(`/dsa/${params.dsaId}/clone`, params),
    'clone_dsa',
    params
  );
};

export const convertCustomerDSA = params => {
  return wrapCall(
    api.post(`/dsa/${params.dsaId}/convert-customer`, params),
    'convert_customer_dsa',
    params
  );
};

export const convertDSA = dsaId => {
  return wrapCall(
    api.post(`/dsa/${dsaId}/convert`),
    'convert_dsa',
    { dsaId }
  );
};

export const toggleAccountDSASort = by => {
  return {
    type: types.TOGGLE_ACCOUNT_DSA_SORT,
    by
  };
};

export const toggleAccountDSATypeFilter = () => {
  return {
    type: types.TOGGLE_ACCOUNT_DSA_TYPE_FILTER
  };
};

export const toggleAccountDSAStatusFilter = () => {
  return {
    type: types.TOGGLE_ACCOUNT_DSA_STATUS_FILTER
  };
};

export const toggleSecurityCorrelations = (id, active) => {
  return wrapCall(api.post(`/dsaextension/${id}`, {active}), 'toggle_security_correlations', {id, active});
};

export const generatePPTX = (staticComponents, {
  dsa,
  abilities,
  activeAreas,
  configuredItems,
  dashboardCategories,
  valueRealized,
  securityCorrelations,
  userGroups,
  summary,
  overlapStats,
  newCustomerOverlapStats,
  recommendations,
  subAreas
}) => {
  return wrapCall(
    fileApi.post(
      '/pptx/dsa/render', {
        dsa: dsa,
        areas: activeAreas,
        configuredItems,
        dashboardCategories,
        valueRealized,
        securityCorrelations,
        userGroups,
        summary,
        abilities,
        components: staticComponents,
        overlapStats: overlapStats,
        newCustomerOverlapStats: newCustomerOverlapStats,
        recommendations,
        subAreas
      }), 'generate_pptx', {
        dsa,
        activeAreas,
        dashboardCategories,
        valueRealized,
        securityCorrelations,
        userGroups,
        summary,
        abilities,
        staticComponents,
        overlapStats,
        newCustomerOverlapStats,
        recommendations,
        subAreas
      });
};

export const createCustomConfiguredItem = (dsaId, subareaId) => {
  return wrapCall(
    api.post('/dsaconfigureditem', {dsa: dsaId, subarea: subareaId}),
    'create_dsa_custom_configured_item',
    { dsaId, subareaId }
  );
};

const int = n => parseInt(n, 10) || 0;

export const dismissTrainingSnackbar = () => {
  return {
    type: types.DISMISS_TRAINING_SNACKBAR
  };
};



// WEBPACK FOOTER //
// ./src/actions/dsaActions.js